import {
  BlockText,
  BlockHeading,
  BlockSlider,
  BlockMedia,
  BlockOpenPositions,
  BlockContactLinks,
} from './templates'

export const resolveBlock = (data) => {
  let block

  // Map layout strings to blocks
  const blocks = {
    text: BlockText,
    heading: BlockHeading,
    image_slider: BlockSlider,
    image: BlockMedia,
    video: BlockMedia,
    video_block: BlockMedia,
    text_block: BlockText,
    image_block: BlockSlider,
    open_positions: BlockOpenPositions,
    contact_links: BlockContactLinks,
  }

  return blocks[data.type]
}
